import { render, staticRenderFns } from "./redSetting.vue?vue&type=template&id=0369ae39"
import script from "./redSetting.vue?vue&type=script&lang=js"
export * from "./redSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports